module.exports = __webpack_public_path__ + "static/img/scene_pic2.4659a5e.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/scene_pic2.png
// module id = K+NT
// module chunks = 1